import { Mixer } from '@tunasong/icons'
import type { ListItemProps, TypographyProps } from '@tunasong/ui-lib'
import { Dialog, Typography, ListItemButton, ListItemIcon, ListItemText } from '@tunasong/ui-lib'
import React, { useState } from 'react'
import { AudioMixer } from './audio-mixer.js'
import styles from './mixer-menu.module.css'

export interface MixerMenuItemProps extends Omit<ListItemProps, 'button'> {
  variant?: TypographyProps['variant']
  onClose?: () => void
}

export const useMixerMenuItem = (props: MixerMenuItemProps = {}) => {
  const { onClose, onClick, variant = 'body1' } = props

  const [showMixer, setShowMixer] = useState(false)
  const handleShowMixer = (ev: React.MouseEvent<HTMLDivElement>) => {
    ev.preventDefault()
    if (onClick) {
      onClick(ev as unknown as React.MouseEvent<HTMLLIElement>)
    }
    setShowMixer(true)
  }
  const handleHideMixer = () => {
    setShowMixer(false)
    if (onClose) {
      onClose()
    }
  }

  return {
    dialog: (
      <Dialog fullScreen open={showMixer} onClose={handleHideMixer} title="Mixer" fullWidth={true} maxWidth="sm">
        <AudioMixer />
      </Dialog>
    ),
    menuItem: (
      <ListItemButton title="Mixer" onClick={handleShowMixer}>
        <ListItemIcon className={styles.listItemIcon}>
          <Mixer />
        </ListItemIcon>
        <ListItemText>
          <Typography variant={variant}>Mixer</Typography>
        </ListItemText>
      </ListItemButton>
    ),
  }
}
